(function(){
   var _initialized = false,
      _actions = [],
      _services = {},
      _initCallbacks = [],
      _config = {},
      Flup = {};

   function _flup(key){
      var service = _services[key];
      if(!service) return null;
      if(service.instance === null){
         service.instance = new service.creator(_flup, _config[key]||{});
      }
      return service.instance;
   }

   _flup.reset = function($context, html, isInnerHtml){
      $context = $context || $("html");
      if(html !== undefined){
         if(isInnerHtml){
            $context.html(html);
         }else{
            var $html = $(html);
            $context.replaceWith($html);
            $context = $html;
         }
      }
      _actions.forEach(function(action){
         var attr = "fl-"+action.attr;
         $context.find("["+attr+"]").each(function(){
            var $elm = $(this), value = $elm.attr(attr);
            if(action.event){
               $elm.on(action.event, function(e){
                  action.func(_flup, $elm, value, e);
               });
               if(action.autoTrigger) action.func(_flup, $elm, value);
            }else{
               action.func(_flup, $elm, value);
            }
            $elm.removeAttr(attr);
         });
      });
   }

   _flup.config = function(serviceKey){
      return _config[serviceKey]||{};
   }

   Flup.service = function(key, func){
      if(_initialized) return;
      _services[key] = {
         instance: null,
         creator: func,
      };
   }

   Flup.config = function(serviceKey, data){
      if(typeof serviceKey === "object"){
         for(var x in serviceKey){
            Flup.config(x, serviceKey[x]);
         }
      }else{
         _config[serviceKey] = _config[serviceKey]||{};
         $.extend(_config[serviceKey], data);
      }
   }

   Flup.on = function(event, attr, func, autoTrigger){
      if(_initialized) return;
      _actions.push({
         event: event,
         attr: attr, 
         func: func,
         autoTrigger: autoTrigger
      });
   }

   Flup.link = function(attr, func){
      Flup.on(null, attr, func);
   }

   Flup.click = function(attr, func, autoTrigger){
      Flup.on("click", attr, func, autoTrigger);
   }

   Flup.init = function(func){
      _initCallbacks.push(func);
   }

   Flup.start = function(){
      if(_initialized) return;
      _initialized = true;
      _initCallbacks.forEach(function(func){
         func(_flup);
      });
      _flup.reset();
   }

   window.Flup = Flup;
})();